import React from 'react';
import type { FormConfig } from '@tencent/wb-ext-form';
import { FormItemType } from '@src/framework/workbench/drawer/constants';
import { config as topConfig } from '@framework/workbench/ui/move/move-top/config';
import { config as bottomConfig } from '@framework/workbench/ui/move/move-bottom/config';
import { config as upConfig } from '@framework/workbench/ui/move/move-up/config';
import { config as downConfig } from '@framework/workbench/ui/move/move-down/config';
import {
    MOVE_TOP_ICON,
    MOVE_BOTTOM_ICON,
    MOVE_UP_ICON,
    MOVE_DOWN_ICON,
} from '@framework/workbench/drawer/image';
import Style from '@framework/workbench/drawer/ui/index.less';

export const FORM_CONFIGS_MOVE_TOP: FormConfig[] = [
    {
        type: FormItemType.BUTTON,
        name: topConfig.id,
        label: topConfig.content,
        options: {
            icon: <img src={MOVE_TOP_ICON} alt={''} className={Style['btn-icon']}/>,
        },
        style: {
            fontSize: '12px',
        },
    },
];

export const FORM_CONFIGS_MOVE_BOTTOM: FormConfig[] = [
    {
        type: FormItemType.BUTTON,
        name: bottomConfig.id,
        label: bottomConfig.content,
        options: {
            icon: <img src={MOVE_BOTTOM_ICON} alt={''} className={Style['btn-icon']}/>,
        },
        style: {
            fontSize: '12px',
        },
    },
];

export const FORM_CONFIGS_MOVE_UP: FormConfig[] = [
    {
        type: FormItemType.BUTTON,
        name: upConfig.id,
        label: upConfig.content,
        options: {
            icon: <img src={MOVE_UP_ICON} alt={''} className={Style['btn-icon']}/>,
        },
        style: {
            fontSize: '12px',
        },
    },
];

export const FORM_CONFIGS_MOVE_DOWN: FormConfig[] = [
    {
        type: FormItemType.BUTTON,
        name: downConfig.id,
        label: downConfig.content,
        options: {
            icon: <img src={MOVE_DOWN_ICON} alt={''} className={Style['btn-icon']}/>,
        },
        style: {
            fontSize: '12px',
        },
    },
];
